import { includes } from "./../../core/keep-alive/keepAlive";
import _ from "lodash";
import Cookies from "js-cookie";
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  reactive,
  Ref,
  toRefs,
  watch,
  onActivated,
  ref,
  nextTick,
} from "vue";
import { SalesManService } from "@/components/sales-man-select/sales-man.service";
import { TreeNode, UserRecord } from "./user-role-select.interface";
import { UserSelectService } from "./user-role-select.service";
import { useEventbus } from "@/core";
import { bindEmitter } from "@/utils/emitter";
import Icon, { UserOutlined, ForkOutlined } from "@ant-design/icons-vue";
import { Form, message } from "ant-design-vue";
import { RoleService } from "@/views/organization/role/role.service";
import { RolePageReq } from "@/views/organization/role/role.interface";
import { DictValService } from "@/views/data-dict/dict/dict-val.service";
import { DictValPageReq } from "@/views/data-dict/dict/dict-val.interface";
/**
 * 员工选择器
 *
 * <user-select v-model:value="formRef.userIds"></user-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "UserRoleSelect",
  components: { UserOutlined, ForkOutlined },
  props: {
    value: {
      type: [Array] as PropType<any[]>,
      default: () => [],
    },
    userStatus: {
      //转正状态
      type: String,
      default: "",
    },
    // 是否展示员工列表
    showUserList: { type: Boolean, default: true },

    disabled: { type: Boolean, default: false },

    multiple: { type: Boolean, default: false },

    maxCount: { type: Number, default: 1 },
    maxRoleCount: { type: Number, default: 1 },
    activatedStatus: {
      type: Number,
      default: undefined,
    },
    status: {
      type: Number,
      default: undefined,
    },
    onJob: {
      type: Boolean,
      default: undefined,
    },
    formName: {
      type: Array,
      default: () => [],
    },
    validate: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: undefined,
    },
    // 是否有劳务班组
    staffType: { type: [String], default: "no_type" },
  },
  emits: ["update:value", "change", "close"],
  setup(props, { emit }) {
    const state = reactive({
      visible: false,
      userSearchId: undefined,
      treeData: [],
      loadedKeys: [],
      expandedKeys: [],
      tempUsers: [],
      selectedUsers: [],
      innerMaxCount: computed(() => {
        return props.multiple ? props.maxCount : 1;
      }),
      selectedUserIds: computed(() => {
        return state.selectedUsers.map((item) => item.id);
      }),
      isError: false,
      usersStaffType: computed(() => {
        return props.staffType ? null : "all";
      }),
      selectedRoles: [],
      selectedRoleIds: [],
      rolesData: [],
      tempRoles: [],
      selectedProjectRoles: [],
      selectedProjectRoleIds: [],
      tempProjectRoles: [],
      projectRoles: [],
    });
    const { $on } = useEventbus();
    const formItemContext = Form.useInjectFormItemContext();
    const loadDepartment = async ({ row: record }) => {
      const id = record.id;
      const records = await UserSelectService.fetchRecords(
        { state: props.userStatus, staffType: props.staffType },
        id,
        state.usersStaffType
      );
      return records;
    };
    bindEmitter("trigger-form-custom-validator", async () => {
      if (props.validate) {
        if (!props.value) {
          state.isError = true;
          formItemContext.onFieldChange();
          state.tempUsers = [];
        }
      } else {
        if (!props.value) {
          state.tempUsers = [];
        }
      }
    });
    bindEmitter("trigger-keepalive-form-reset", () => {
      state.isError = false;
    });
    $on("form-error", (data) => {
      if (props.formName.length && data.length) {
        let nameString = props.formName.join(",");
        for (let i = 0; i < data.length; i++) {
          let errorString =
            typeof data[i]["name"] == "string" ? data[i]["name"] : data[i]["name"].join(",");
          if (errorString === nameString) {
            state.isError = true;
            break;
          } else {
            state.isError = false;
          }
        }
      }
    });
    const activeKey = ref("1");
    const columns = [
      {
        title: "角色名称",
        width: 250,
        dataIndex: "name",
        key: "name",
      },
    ];
    const tableRef = ref();
    const showModal = async () => {
      state.userSearchId = undefined;

      if (props.disabled) return;
      state.visible = true;
      let tmp = await UserSelectService.fetchRecords(
        { state: props.userStatus, staffType: props.staffType },
        0
      );
      tmp.forEach((o: any) => {
        if (o.hasChildren === undefined) {
          o.hasChildren = !o.isLeaf;
        }
      });
      state.treeData = tmp;
      
      // console.log("🚀 ~ file: user-role-select.controller.ts:180 ~ showModal ~ selectedRoles:", state.selectedRoles,state.selectedProjectRoles)
      nextTick(() => {
        if (tableRef && tableRef.value) {
          tableRef.value.xTable1?.clearCheckboxRow();
          tableRef.value.xTable1?.setCheckboxRow(state.selectedRoles, true);
        }
        if (tableRef2 && tableRef2.value) {
          tableRef2.value.xTable1?.clearCheckboxRow();
          tableRef2.value.xTable1?.setCheckboxRow(state.selectedProjectRoles, true);
        }
      });
    };
    const onSelectionChange = (ids: []) => {
      state.selectedRoleIds = ids;
      state.tempRoles = (state.rolesData.filter((r: any) => state.selectedRoleIds.includes(r.id)) ||
        []) as any;
    };

    const triggerUpdate = () => {
      const ids = state.tempUsers.map((o: any) => o.id);
      let sUser = state.tempUsers.reduce((pre: any, cur: any) => {
        pre.push({ tenantUserId: cur.id, type: 0, code: "", roleId: 0 });
        return pre;
      }, []);
      let sRole = state.tempRoles.reduce((pre: any, cur: any) => {
        pre.push({ roleId: cur.id, tenantUserId: null, type: 1 });
        return pre;
      }, []);
      let sRole2 = state.tempProjectRoles.reduce((pre: any, cur) => {
        pre.push({ roleId: cur.id, code: cur.valCode, tenantUserId: null, type: 2 });
        return pre;
      }, []);

      // if (state.tempUsers.length === 0) {
      //   emit("update:value", props.maxCount > 1 ? [] : "");
      //   emit("change", state.tempUsers);
      //   formItemContext.onFieldChange();
      //   return;
      // }
      emit("update:value", [...sUser, ...sRole, ...sRole2]);
      emit("change", [...state.tempUsers, ...state.tempProjectRoles, ...state.tempRoles]);
      formItemContext.onFieldChange();
    };

    const ok = () => {
      if (state.tempUsers.length > 0) {
        state.isError = false;
      }
      if (
        props.maxRoleCount &&
        props.maxRoleCount > 0 &&
        state.tempRoles.length + state.tempProjectRoles.length > props.maxRoleCount
      ) {
        message.warn(`最多只能选择${props.maxRoleCount}个角色`);
        return;
      }
      triggerUpdate();
      state.visible = false;
    };

    const deleteTempUser = (deletedId) => {
      state.tempUsers = state.tempUsers.filter((item) => item.id !== deletedId);
    };
    const deleteTempRole = (deletedId) => {
      state.tempRoles = state.tempRoles.filter((item) => item.id !== deletedId);
      state.selectedRoles = [...state.tempRoles];
      // // console.log(
      //   "🚀 ~ file: user-role-select.controller.ts:201 ~ deleteTempRole ~ tableRef:",
      //   tableRef
      // );
      if (tableRef && tableRef.value) {
        tableRef.value.xTable1?.clearCheckboxRow();
        tableRef.value.xTable1?.setCheckboxRow(state.selectedRoles, true);
      }
    };

    const deleteSelectedUser = (deletedId) => {
      state.tempUsers = state.tempUsers.filter((item) => item.id !== deletedId);
      state.tempUsers.length == 0 && (state.isError = true);
      triggerUpdate();
      emit("close", "");
    };
    const { run: runRole, loading } = RoleService.usePageApi();
    const queryRef = reactive(new RolePageReq());
    const loadRoles = async () => {
      queryRef.current = 1;
      queryRef.size = 10000;
      const res = await runRole(queryRef);
      state.rolesData = (res.data?.records || []) as any;
    };
    const setSelectedRoles = async (datas) => {
      let roleList = datas?.filter((v) => v.type == "1") || [];
      const ids = roleList.reduce((pre: any, cur: any) => {
        pre.push(cur.roleId);
        return pre;
      }, []);
      if (ids.length == 0) {
        state.tempRoles = [];
        state.selectedRoleIds = [];
        state.selectedRoles = [];
        return;
      } else {
        if (state.rolesData.length == 0) {
          await loadRoles();
        }
        state.selectedRoleIds = ids;
        state.tempRoles = (state.rolesData.filter((r: any) =>
          state.selectedRoleIds.includes(r.id)
        ) || []) as any;
        state.selectedRoles = [...state.tempRoles];
      }
    };
    const deleteSelectedRole = (deletedId) => {
      state.tempRoles = state.tempRoles.filter((item) => item.id !== deletedId);
      state.selectedRoles = state.selectedRoles.filter((item) => item.id !== deletedId);
      state.selectedRoleIds = state.selectedRoleIds.filter((item) => item !== deletedId);
      triggerUpdate();
    };
    const { run } = SalesManService.useSimpleListApi();
    const setSelectedUsers = async (value: any[]) => {
      // // console.log(
      //   "🚀 ~ file: user-role-select.controller.ts:277 ~ setSelectedUsers ~ value:",
      //   value
      // );
      let userList = value?.filter((v) => v.type == "0" || v.tenantUserId) || [];
      const ids = userList.reduce((pre: any, cur: any) => {
        pre.push(cur.tenantUserId);
        return pre;
      }, []);

      const res = await run({ ids });
      if (res.respCode === "0000") {
        state.tempUsers = (res.data?.records || [])
          .filter((item) => ids.includes(item.id))
          .reduce((pre: any, cur) => {
            pre.push({ id: cur.id, name: cur.realName });
            return pre;
          }, []);
      }
    };

    const onUserSearchSelect = (user) => {
      const tempUserIds = state.tempUsers.map((item) => item.id);
      const { id, realName: name } = user;
      const userId = UserSelectService.parseUserId(id);
      if (!tempUserIds.includes(userId)) {
        if (props.maxCount > state.tempUsers.length) {
          state.tempUsers.push({ id: userId, name });
        } else {
          state.tempUsers[props.maxCount - 1] = { id: userId, name };
        }
      }
    };

    watch(
      () => props.value,
      (n) => {
        // console.log("🚀 ~ file: user-role-select.controller.ts:307 ~ setup ~ n:", n);
        state.isError = false;
        if (props.validate) {
          if (!props.value) {
            state.isError = true;
            formItemContext.onFieldChange();
            state.tempUsers = [];
            state.tempRoles = [];
          state.tempProjectRoles = [];
          if (tableRef && tableRef.value) {
            tableRef.value.xTable1?.clearCheckboxRow();
          }
          if (tableRef2 && tableRef2.value) {
            tableRef2.value.xTable1?.clearCheckboxRow();
          }
          } else {
            setSelectedUsers(n || []);
            setSelectedProjectRoles(n || []);
            setSelectedRoles(n || []);
            state.isError = false;
          }
        } else {
          if (!props.value) {
            state.tempUsers = [];
            state.tempRoles = [];
          state.tempProjectRoles = [];
          if (tableRef && tableRef.value) {
            tableRef.value.xTable1?.clearCheckboxRow();
          }
          if (tableRef2 && tableRef2.value) {
            tableRef2.value.xTable1?.clearCheckboxRow();
          }
          } else {
            setSelectedUsers(n || []);
            setSelectedProjectRoles(n || []);
            setSelectedRoles(n || []);
          }
        }
      },
      { deep: true }
    );

    //点击叶子结点
    const clickRow = (row) => {
      //是叶子结点，同时不是部门节点
      if (row.isLeaf && !row.isDepartment) {
        //判断是否可以多选
        if (props.maxCount > state.tempUsers.length) {
          if (!state.tempUsers.some((o) => o.id === row.id)) {
            //检查点击的数组是否有重复的人员id，如果有不添加，如果没有添加进数组
            state.tempUsers.push({ id: row.id, name: row.name });
          }
        } else {
          state.tempUsers[props.maxCount - 1] = { id: row.id, name: row.name };
        }
      }
    };
    const cancelFn = () => {
      // state.tempUsers = [];
      state.isError = false;
      if (props.validate) {
        if (!props.value) {
          state.isError = true;
          formItemContext.onFieldChange();
          state.tempUsers = [];
          state.tempRoles = [];
          state.tempProjectRoles = [];
          if (tableRef && tableRef.value) {
            tableRef.value.xTable1?.clearCheckboxRow();
          }
          if (tableRef2 && tableRef2.value) {
            tableRef2.value.xTable1?.clearCheckboxRow();
          }
        } else {
          setSelectedUsers(props.value || []);
          setSelectedRoles(props.value || []);
          setSelectedProjectRoles(props.value || []);

          state.isError = false;
        }
      } else {
        if (!props.value) {
          state.tempUsers = [];
          state.tempRoles = [];
          state.tempProjectRoles = [];
          if (tableRef && tableRef.value) {
            tableRef.value.xTable1?.clearCheckboxRow();
          }
          if (tableRef2 && tableRef2.value) {
            tableRef2.value.xTable1?.clearCheckboxRow();
          }
        } else {
          setSelectedUsers(props.value || []);
          setSelectedRoles(props.value || []);
          setSelectedProjectRoles(props.value || []);
        }
      }
    };

    //组织角色
    const { data, run: projectRoleRun, refresh, pagination } = DictValService.usePageApi();

    const loadProjectRoles = async () => {
      const queryRef2 = reactive(new DictValPageReq({ dictCode: "project_role", enable: true }));
      queryRef2.current = 1;
      queryRef2.size = 10000;
      let res = await projectRoleRun(queryRef2);
      // console.log("🚀 ~ file: user-role-select.controller.ts:353 ~ loadProjectRoles ~ res:", res);
      state.projectRoles = res?.data?.records || [];
    };
    const columns2 = [
      {
        title: "项目角色",
        width: 250,
        dataIndex: "valName",
        key: "valName",
      },
    ];
    const tableRef2 = ref();
    const onSelectionChange2 = (ids: []) => {
      // console.log("🚀 ~ file: user-role-select.controller.ts:366 ~ onSelectionChange2 ~ ids:", ids);
      state.selectedProjectRoleIds = ids;
      state.tempProjectRoles = (state.projectRoles.filter((r: any) =>
        state.selectedProjectRoleIds.includes(r.id)
      ) || []) as any;
    };
    const deleteTempProjectRole = (deletedId) => {
      state.tempProjectRoles = state.tempProjectRoles.filter((item) => item.id !== deletedId);
      state.selectedProjectRoles = [...state.tempProjectRoles];
      // // console.log(
      //   "🚀 ~ file: user-role-select.controller.ts:201 ~ deleteTempRole ~ tableRef:",
      //   tableRef
      // );
      if (tableRef2 && tableRef2.value) {
        tableRef2.value.xTable1?.clearCheckboxRow();
        tableRef2.value.xTable1?.setCheckboxRow(state.selectedProjectRoles, true);
      }
    };
    const deleteSelectedProjectRole = (deletedId) => {
      state.tempProjectRoles = state.tempProjectRoles.filter((item) => item.id !== deletedId);
      state.selectedProjectRoles = state.selectedProjectRoles.filter(
        (item) => item.id !== deletedId
      );
      state.selectedProjectRoleIds = state.selectedProjectRoleIds.filter(
        (item) => item !== deletedId
      );
      triggerUpdate();
      // emit("update:value", props.maxCount > 1 ? state.selectedProjectRoleIds : state.selectedProjectRoleIds[0]);
    };
    const setSelectedProjectRoles = async (datas) => {
      let projectRoleList = datas?.filter((v) => v.type == "2") || [];
      const codes = projectRoleList.reduce((pre: any, cur: any) => {
        pre.push(cur.code);
        return pre;
      }, []);
      if (codes.length == 0) {
        state.tempProjectRoles = [];
        state.selectedProjectRoleIds = [];
        state.selectedProjectRoles = [];
        return;
      } else {
        if (state.projectRoles.length == 0) {
          await loadProjectRoles();
        }
        state.tempProjectRoles = (state.projectRoles.filter((r: any) =>
        codes.includes(r.valCode)
        ) || []) as any;
        state.selectedProjectRoleIds = state.tempProjectRoles.reduce((pre: any, cur: any) => {
          pre.push(cur.id);
          return pre;
        }, []);;

        state.selectedProjectRoles = [...state.tempProjectRoles];
      }
    };
    onMounted(async () => {
      await loadRoles();
      await loadProjectRoles();
      setSelectedUsers(props.value || []);
      setSelectedProjectRoles(props.value || []);
      setSelectedRoles(props.value || []);
      state.isError = false;
    });
    onActivated(() => {
      state.isError = false;
    });
    return {
      ...toRefs(state),
      loadDepartment,
      showModal,
      ok,
      cancelFn,
      deleteTempUser,
      deleteSelectedUser,
      onUserSearchSelect,
      clickRow,
      columns,
      tableRef,
      tableRef2,
      activeKey,
      onSelectionChange,
      loading,
      deleteSelectedRole,
      deleteTempRole,
      columns2,
      onSelectionChange2,
      deleteTempProjectRole,
      deleteSelectedProjectRole,
      setSelectedProjectRoles,
    };
  },
});
